import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/rfisReportActions'
import * as api from '../../../api/reports/jobs/rfisReport'

function* rfisReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.RFIS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.RFIS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* rfisReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({
      type: constants.RFIS_REPORT_GET_ORGANIZATION_LIST.SUCCESS,
      payload
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.RFIS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* rfisReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.RFIS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.RFIS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchrfisReportGetJobList() {
  yield takeLatest(constants.RFIS_REPORT_GET_JOB_LIST.ACTION, rfisReportGetJobList)
}

function* watchrfisReportGetOrganizationList() {
  yield takeLatest(
    constants.RFIS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    rfisReportGetOrganizationList
  )
}

function* watchrfisReportGetFullReport() {
  yield takeLatest(constants.RFIS_REPORT_GET_FULL_REPORT.ACTION, rfisReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchrfisReportGetOrganizationList),
    fork(watchrfisReportGetFullReport),
    fork(watchrfisReportGetJobList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/rfisReportSaga.js